export default __webpack_public_path__ + "media/images/features/ana/collaboration_logo-c5476592d0a14953a0affc8862c92dcc.png";